import { GetMusicBoxContentsDto } from '../../../dto/musicboxcontents/getmusicboxcontentsdto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface GetMusicBoxContentsRequest extends APIRequest
{
    getMusicBoxContentsRequest(): GetMusicBoxContentsDto;
}

export class GetMusicBoxContentsRequestImpl extends APIRequestDtoImpl implements GetMusicBoxContentsRequest
{
    constructor(private getMusicBoxContentsData: GetMusicBoxContentsDto)
    {
        super();
    }

    getMusicBoxContentsRequest(): GetMusicBoxContentsDto
    {
        return this.getMusicBoxContentsData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/wishlist/getmusicboxcontents/getmusicboxcontentsrequest.tsx